import { useQuery } from '@tanstack/react-query';
import { getLastMinuteSimulations } from 'Services';
import { getSimulationHashmap, RQ_LAST_MINUTE_SIMULATIONS, RQ_LAST_MINUTE_SIMULATIONS_POILLING_INTERVAL } from 'Utils';

function useGetLastMinuteSimulations(
    enabled: boolean,
    repoId: number,
    shouldPoll: boolean,
    onSuccess?: (data: SimulationsHashmap) => void,
    onError?: (err?: any) => void,
    customDuration?: number
) {
    return useQuery([RQ_LAST_MINUTE_SIMULATIONS, repoId], () => getLastMinuteSimulations(customDuration), {
        enabled: !!(repoId && repoId > 0) && enabled,
        refetchInterval: shouldPoll ? RQ_LAST_MINUTE_SIMULATIONS_POILLING_INTERVAL : undefined,
        refetchIntervalInBackground: true,
        onSuccess,
        onError,
        select: getSimulationHashmap
    });
}

export default useGetLastMinuteSimulations;
